import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy, DoCheck } from '@angular/core';
import { TabOpenService } from '@services/tab-open.service';
import { ReportTabs } from '@fs/enums/report-dashboard-tabs';
import { ActionName } from '@shared/enums/action-name';
import { ISubscription } from "rxjs/Subscription";
import { AuthService } from '@services/auth.service';
import { PermissionPipe } from '@shared/pipes/permission';

@Component({
  selector: 'reports-dashboard',
  templateUrl: './reports-dashboard.component.html',
  styleUrls: ['./reports-dashboard.component.scss']
})
export class ReportsDashboardComponent implements DoCheck {

  //#region Input/Output/ViewChild
  //#endregion

  //#region Variable Declarations
  private subscriptions: ISubscription[] = [];

  public tabCounter: number;
  public isUnsavedTriggered: boolean = false;
  public displayedTab: ReportTabs = ReportTabs.DashBoard;
  public reportTabs = ReportTabs;
  public actionName = ActionName;
  public routeToParent: boolean = false;
  public removeDirtyClass: boolean = false;
  public qbVersion: string = "";
  public showAlert: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    private tabopen: TabOpenService,
    private auth: AuthService,
    private permissionPipe: PermissionPipe) {
    let subscription =
      this.tabopen.alertPopupEvent.subscribe(res => {
        if (res) {
          if (res.data == this.tabCounter) {
            if (this.displayedTab != ReportTabs.DashBoard) {
              this.showAlert = true;
            }
            else {
              this.tabopen.DestroyTab(this.tabCounter, 'closeTab')
            }
          }
        }
      });
    this.subscriptions.push(subscription);
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
  }
  //#endregion

  //#region Lifecycle Events
  ngOnDestroy() {
    this.subscriptions.forEach(subscribed_elem => {
      subscribed_elem.unsubscribe();
    });
  }
  
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.routeToParent;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }
  //#endregion

  //#region Methods

  public CloseTab() {
    if (this.routeToParent) {
      this.displayedTab = ReportTabs.DashBoard;
      this.routeToParent = false;
      this.showAlert = false;
      this.ResetUnsavedTrigger("");
    }
    else
    this.tabopen.DestroyTab(this.tabCounter, 'closeTab');
  }

  public KeepTabOpen() {
    this.showAlert = false;
    this.routeToParent = false;
  }

  public OpenReportTemplate(val: ReportTabs, priv: ActionName) {
    if (this.permissionPipe.transform(priv)) {
      this.isUnsavedTriggered = false;
      this.TriggerUnsavedChanges(true);
      this.displayedTab = val;
    }
  }

  public OpenDashboard() {
    this.showAlert = true;
    this.routeToParent = true;
    this.TriggerUnsavedChanges();
  }

  public ResetUnsavedTrigger(data: any) {
    this.tabopen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
    this.isUnsavedTriggered = false;
  }

  public TriggerUnsavedChanges(isDirty: boolean = false) {
     if (!this.isUnsavedTriggered) {
        this.isUnsavedTriggered = true;
       this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
    }
  }
  //#endregion
}
